import * as angular from "angular";
import {IController} from "angular";

export class BringozSkillsMultiSelectComponent implements IController {
  skills: any;
  agentType: any;
  isDisabled: any;
  ngRequired: any;
  ngPlaceholder: any;
  noUnderline: any;
  options: any;
  onChange: Function;

  skillsByType: any;
  selectOptions: any;

  constructor(private agentConstants, private $mdSelect) {
  }

  $onInit() {
    this.skillsByType = this.agentConstants.skillsByType;
    this.selectOptions = this.options || this.skillsByType[this.agentType || 'All'];
  };

  $onChanges(changes) {
    if (changes.agentType && !changes.agentType.isFirstChange()) {
      this.selectOptions = this.options || this.skillsByType[this.agentType || 'All'];
    }
  };

  reset() {
    this.onChange({skills: undefined});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  select() {
    this.onChange({skills: this.skills});
    this.$mdSelect.hide();
  }


}


angular
  .module('bringoz.admin.commons')
  .component('bringozSkillsMultiSelect', {
    bindings: {
      skills: '<',
      agentType: '<',
      isDisabled: '<?',
      ngRequired: '@?',
      ngPlaceholder: '@?',
      noUnderline: '@?',
      options: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-skills-multi-select/bringoz-skills-multi-select.html',
    controller: BringozSkillsMultiSelectComponent
  });
